const getSongImage = (song, width, height) => {
  const imagesLargeEnough = song.song_images.edges.filter(
    ({ node: image }) => image.width >= width && image.height >= height
  );
  const imageAreas = imagesLargeEnough.map(
    ({ node: image }) => image.width * image.height
  );
  if (imagesLargeEnough.length > 0) {
    return imagesLargeEnough[imageAreas.indexOf(Math.min(...imageAreas))].node;
  }
  return null;
};

const getPlaylistImage = (playlist, width, height) => {
  const playlistSongs = playlist.playlist_songs.edges;
  let i = 0;
  let songImage = null;
  while (!songImage && i < playlistSongs.length) {
    songImage = getSongImage(playlistSongs[i].node.song, width, height);
    i++;
  }
  return songImage;
};

export { getPlaylistImage, getSongImage };



// WEBPACK FOOTER //
// ./webpack/lib/utils/playlist.js